export default __webpack_public_path__ + "static/media/tour-4.d1d0e0a3.svg";